import {
  Box,
  Button,
  Chip,
  Link,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import React from "react";
import {
  CustomDetailsList,
  CustomeDialog,
  CustomTable,
  DeleteModal,
  Loader,
  PageListLayout,
} from "../../../shared";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { createColumnHelper } from "@tanstack/react-table";
import { useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useSyncHistoryDetails } from "../hooks";
import moment from "moment";

export const SyncHistoryDetails = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const { state, syncDetails } = useSyncHistoryDetails({ syncID: id });
  const { data, isLoading } = state;
  const breadcrumbs = [
    <Link
      underline="none"
      key="1"
      color="#1760D2"
      onClick={(e) => navigate("/pos-sync")}
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      POS Sync
    </Link>,
    <Typography
      key="2"
      color="inherit"
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      Sync Run :{" "}
      {syncDetails?.data?.sync_date &&
        moment(syncDetails?.data?.sync_date, "DD-MM-YYYY, hh:mm A").format(
          "DD-MM-YYYY",
        )}
    </Typography>,
  ];

  const columnHelper = createColumnHelper();

  const columns = [
    {
      title: "Sync Date",
      accessor: "sync_date",
    },
    {
      title: "User",
      accessor: "user",
    },
    {
      title: "Remarks",
      accessor: "remarks",
    },
  ];

  const columns3 = [
    columnHelper.accessor("plu", {
      header: () => "PLU Code",
    }),
    columnHelper.accessor("product_name", {
      header: () => "Finished Product Name",
      cell: ({ getValue, row: { original } }) => (
        <Typography
          onClick={() =>
            navigate(`/recipe/details/${original?.product_id}?basic-details`)
          }
          variant="subtitle2"
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
            color: "neutral.10",
          }}
        >
          {getValue()}
        </Typography>
      ),
    }),
    columnHelper.accessor("cost_exc_gst", {
      header: () => "Updated Cost (Ex GST)",
      cell: ({ getValue }) => {
        const value = getValue();
        return `$${typeof value === "number" ? value.toFixed(3) : value}`;
      },
    }),
  ];

  return (
    <PageListLayout
      headerText={
        <>
          {syncDetails?.data?.sync_date ? (
            <Stack alignItems="center" direction="row" gap="12px">
              <Typography variant="h6" fontWeight={600} fontSize="24px">
                Sync Run :{" "}
                {moment(
                  syncDetails?.data?.sync_date,
                  "DD-MM-YYYY, hh:mm A",
                ).format("DD-MM-YYYY")}
              </Typography>
              {syncDetails?.data?.status_id === 1 ? (
                <Chip
                  size="small"
                  color="primary"
                  variant="filled"
                  label="SUCCESS"
                />
              ) : (
                <Chip size="small" color="errorChip" label="FAILED" />
              )}
            </Stack>
          ) : (
            "loading..."
          )}
        </>
      }
      breadcrumbs={breadcrumbs}
      isChanged={false}
      sx={{
        backgroundColor: "#ffffff",
        p: 0,
      }}
    >
      {syncDetails?.isLoading ? (
        <Stack
          minHeight="calc(100vh - 120px)"
          alignContent="center"
          justifyContent="center"
        >
          <Loader />
        </Stack>
      ) : (
        <Stack
          sx={{
            borderRadius: "4px",
            bgcolor: "#fff",
            px: "16px",
            gap: "20px",
          }}
        >
          <CustomDetailsList
            columns={columns}
            data={syncDetails?.data}
            title="Basic Details"
          />

          <CustomTable
            defaultData={syncDetails?.data?.items || []}
            columns={columns3}
            // isPagination={false}
            headerText="Finished Products"
            showSearchBar={false}
            emptyTableMessage={"No finished products"}
          />
        </Stack>
      )}
    </PageListLayout>
  );
};
